"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localText = void 0;
exports.localText = {
    updating: 'Updating status, please wait.',
};
